/* eslint-disable prettier/prettier */
import React from 'react';
import { useNavigate } from 'react-router-dom';

type LogoProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: boolean;
};

export const Logo = ({ size = 'md', className = '', onClick }: LogoProps) => {
  const navigate = useNavigate();

  const sizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
  };

  return (
    <span
      className={`font-bold text-primary ${sizes[size]} ${className} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick ? () => navigate('/') : undefined}
    >
      Treaty Reader
    </span>
  );
};
